import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';
import _Object$keys from 'babel-runtime/core-js/object/keys';
var isAllowed = function isAllowed(propKey, regexes) {
  return regexes.some(function (regex) {
    return propKey.match(regex);
  });
};

var createFilter = function createFilter() {
  for (var _len = arguments.length, regexes = Array(_len), _key = 0; _key < _len; _key++) {
    regexes[_key] = arguments[_key];
  }

  return function (props) {
    return _Object$keys(props).filter(function (propKey) {
      return isAllowed(propKey, regexes);
    }).reduce(function (dataProps, key) {
      return _extends({}, dataProps, _defineProperty({}, key, props[key]));
    }, {});
  };
};

var regexAria = /^aria-.+/;
var regexData = /^data-.+/;
var toRegExp = function toRegExp(arr) {
  return new RegExp('^(' + arr.join('|') + ')$');
};

/*
 * ! Update style-guide (components-common-props.md) also !
 * Bellowed list of props is described also in common section of ui-kit style-guide.
 * After you made change here, please update docs accordingly.
 */
export var htmlGlobalAttr = ['accessKey', 'contentEditable', 'contextMenu', 'dir', 'draggable', 'dropZone', 'hidden', 'id', 'lang', 'role', 'spellCheck', 'style', 'tabIndex', 'title', 'translate'];

export var getAriaAttributes = createFilter(regexAria);
export var getDataAttributes = createFilter(regexData);
export var getHtmlGlobalAttr = createFilter(toRegExp(htmlGlobalAttr));
export var getAllowedAttributes = createFilter(regexAria, regexData, toRegExp(htmlGlobalAttr));
//# sourceMappingURL=props-filters.js.map